// import hooks
import { useCallback, useState, useSyncExternalStore, useRef } from "react";
export const useLocalStorage = (storageKey, initialValue) => {
    const [stateValue, setStateValue] = useState(initialValue);
    const previousValue = useRef(initialValue);
    const value = useSyncExternalStore((updateSnapshot) => {
        const callback = (e) => {
            if (e.key === storageKey) {
                updateSnapshot();
            }
        };
        window.addEventListener("storage", callback);
        return () => {
            window.removeEventListener("storage", callback);
        };
    }, () => {
        const currentValue = window.localStorage.getItem(storageKey);
        if (!currentValue) {
            if (storageKey.trim()) {
                window.localStorage.setItem(storageKey, JSON.stringify(initialValue));
            }
            return initialValue;
        }
        if (JSON.stringify(previousValue.current) !== currentValue) {
            previousValue.current = JSON.parse(currentValue);
        }
        return previousValue.current;
    }, () => initialValue);
    const setValue = useCallback((newValue) => {
        if (storageKey.trim()) {
            window.localStorage.setItem(storageKey, JSON.stringify(newValue));
            window.dispatchEvent(new StorageEvent("storage", {
                key: storageKey,
                newValue: JSON.stringify(newValue),
            }));
        }
        else {
            setStateValue(newValue);
        }
    }, [storageKey]);
    return [storageKey.trim() ? value : stateValue, setValue];
};
export default useLocalStorage;
